import { z } from 'zod';
import { ownershipDetails, smeDirectorBasic, smeDirectorWithLicence } from '../shared';
import { ApplicantType } from '../types';

export {
  smeDirectorWithLicence,
  smeDirectorBasic,
  partnershipOwnershipDetails,
  proprietaryLimitedCompanyOwnershipDetails,
  trustOwnershipDetails,
  soleTraderOwnershipDetails,
  otherOwnershipDetails,
  ownershipDetails,
} from '../shared';

export const ownershipDetailsFormSchema = z.object({
  enterprise: ownershipDetails,
  applicant: z.object({
    type: z.nativeEnum(ApplicantType),
  }),
});

export type OwnershipDetailsType = z.infer<typeof ownershipDetailsFormSchema>;
export type SmeDirectorBasicType = z.infer<typeof smeDirectorBasic>;
export type SmeDirectorWithLicenceType = z.infer<typeof smeDirectorWithLicence>;
